export default "<textarea class=\"error\" cols=\"90\" rows=\"10\">{{data.error}}</textarea>\n"